import { Button, TextField } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import React, { Component } from 'react';
import { Port } from '..';
import { PointFormEditor } from './PointFormEditor';
import produce from "immer"
import { MdGpsFixed } from 'react-icons/md';
import { BsArrowUpRight } from "react-icons/bs";
import { Form } from 'react-bootstrap';

export { PortFormEditor }

function PortFormEditor(props: {
  port: Port
  inline?: boolean
  onChange: (port: Port) => void
}){

  const changePosition = (point: [number, number]) => {
    const port = produce(props.port, (draft: Port) => {
      draft.position = point
    })
    props.onChange(port)
  }

  const changeDirection = (direction: [number, number]) => {
    const port = produce(props.port, (draft: Port) => {
      draft.direction = direction
    })
    props.onChange(port)
  }

  const positionLabel = <><MdGpsFixed />&nbsp; Position</>
  const directionLabel = <><BsArrowUpRight />&nbsp; Direction</>

  return <div>
    <Form
      inline={props.inline !== undefined && props.inline}
    >
      <PointFormEditor
        point={props.port.position}
        onChange={changePosition}
        label={positionLabel}
      />
      <PointFormEditor
        point={props.port.direction}
        onChange={changeDirection}
        label={directionLabel}
      />
    </Form>
    </div>
}
